"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForestLandEnteringEtsSchema = void 0;
exports.ForestLandEnteringEtsSchema = {
    geometry: 'Polygon',
    properties: {
        SID: 'int:10',
        GLOBALID: 'str:50',
        CAA_NUMBER: 'str:4',
        ESTABLISHM: 'int:10',
        FOREST_TYP: 'int:10',
        START_DATE: 'date',
        END_DATE: 'date',
        YEAR_FIRST: 'int:10',
        LAND_ACTIV: 'int:10',
        PREDOMINAN: 'int:10',
        OTHER_PRED: 'str:100',
        TREE_SPECI: 'int:10',
        OTHER_TREE: 'str:100',
        STEM_COUNT: 'int:10',
        Q_LAND_ACT: 'int:10',
        RIGHTS_LEA: 'date',
        GFF_EXPIRY: 'date',
        COMPARTMEN: 'str:50',
        FOREST_NUM: 'str:50',
    },
};
